import { SourceType } from "@gx/ts-contracts/services/database/models/public_pb";

export enum CreateSourceStep {
  SELECT = "select",
  CONFIGURE = "configure",
}

export interface CreateSourceModalProps {
  onClose: () => void;
}

export interface CreateSourceSelectorProps {
  onClose: () => void;
  onSelect: (sourceType: SourceType) => void;
}
